import { AxiosError, AxiosResponse } from "axios";
import {
	IGetListRequest,
	IResponse,
	IServerError,
} from "../../../models/common";

import {
	IManageWageAccount,
	IManageWageAccountResponse,
} from "../../../models/AddOns/Accounting/ManageWageAccount";
import http from "../../../common/http-commons";

export const ManageWageAccountService = {
	getManageWageAccount: async (
		runGetListAPICall: boolean,
		clientId: string,
		wageAccountType: string,
		postingAccount: string,
		// data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IManageWageAccount | IServerError | IResponse | IManageWageAccountResponse[] | null
	> => {
		// const fixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 1,
		// 	items: [
		// 		{
		// 			label: "Check",
		// 			postingAccount: "Test",
		// 			totalEmployees: 3,
		// 			id: "693fab6f6da490b5fe83b84e",
		// 		},
		// 		{
		// 			label: "Check",
		// 			postingAccount: "Test",
		// 			totalEmployees: 4,
		// 			id: "693fab6f6da490b5fe33b84e",
		// 		},
		// 	],
		// 	keyField: {
		// 		field: "manageWageAccountList",
		// 		templateUrl: "/",
		// 	},
		// 	headerColumns: [
		// 		{
		// 			field: "label",
		// 			headerName: "Account Type",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "text",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			alignFrozen: null,
		// 		},
		// 		{
		// 			field: "postingAccount",
		// 			headerName: "Posting Account",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "text",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			alignFrozen: null,
		// 		},
		// 		{
		// 			field: "totalEmployees",
		// 			headerName: "Total Employees",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "text",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			alignFrozen: null,
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(fixedResponse), 1000),
		// );
		if(!runGetListAPICall) return null;
		try {
			const response: AxiosResponse<IManageWageAccount> =
				await http.get<IManageWageAccount>(
					// `/v1/wage-account-employee-assign/get-wage-account-get-list?client_id=${clientId}
					// &wage_account_type=${wageAccountType ? wageAccountType : null}
					// &posting_account=${postingAccount}`
					"/v1/wage-account-employee-assign/get-wage-account-get-list?client_id=" +
						clientId +
						(wageAccountType ? "&wage_account_type=" + wageAccountType : "") +
						(postingAccount ? "&posting_account=" + postingAccount : ""),
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getManageWageAccountById: async (
		ManageWageAccountPageName: string,
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IManageWageAccount | IServerError | IResponse | null | any> => {
		if (!ManageWageAccountPageName) return null;
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IManageWageAccount> =
				await http.get<IManageWageAccount>(
					`/v1/${
						ManageWageAccountPageName === "net_suite"
							? "net-suite"
							: ManageWageAccountPageName === "zoho_books"
								? "zoho-books"
								: ManageWageAccountPageName === "quick_books"
									? "quick-books"
									: ManageWageAccountPageName
					}-manage-wage-account/${clientId}/`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any,
	): Promise<IManageWageAccount | IServerError | IResponse | any> => {
		const screenTag = requestPayload.ManageWageAccountPageName;

		try {
			const response: AxiosResponse<IManageWageAccount> =
				await http.post<IManageWageAccount>(
					`/v1/${
						screenTag === "net_suite"
							? "net-suite"
							: screenTag === "zoho_books"
								? "zoho-books"
								: screenTag === "quick_books"
									? "quick-books"
									: screenTag
					}-manage-wage-account/${requestPayload.clientId}`,
					requestPayload,
				);

			if (response.status === 200) {
				return response;
			} else if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delManageWageAccount: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		const screenTag = delPayload.ManageWageAccountPageName;
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/${
					screenTag === "net_suite"
						? "net-suite"
						: screenTag === "zoho_books"
							? "zoho-books"
							: screenTag === "quick_books"
								? "quick-books"
								: screenTag
				}-manage-wage-account/${delPayload.clientId}/`,
			);

			if (response.status === 204) {
				return "Manage Wage Account has been deleted successfully";
			} else if (response.status === 200) {
				return "Manage Wage Account has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getWageAccounTypeDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any[]> = await http.get<any[]>(
				`/v1/xero-account-settings/xero-account-setting-ddl?client_id=${clientId}`,
			);
			if (response.status === 200) {
				return response.data;
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},
	getPostingAccountDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any[]> = await http.get<any[]>(
				`/v1/posting-account/ddl?client_id=${clientId}`,
			);
			if (response.status === 200) {
				return response.data;
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},
	getEmployeeAssignUnassignmentDDL: async (
		manageWageAccountPageName: string,
		clientId: string,
		wageAccountType: string,
		postingAccount: string,
	): Promise<any | IServerError | IResponse | null> => {
		if (!manageWageAccountPageName) return null;
		console.log("manageWageAccountPageName", manageWageAccountPageName)
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				// `/v1/statutory-holiday-employee-eligibility/get-eligible-ineligible-employee?client_id=${clientId}`,
				// `/v1/wage-account-employee-assign/get-assign-unassign-employee?client_id=${clientId}&wage_account_type=${wageAccountType}&posting_account=${postingAccount}`,

				"/v1/wage-account-employee-assign/get-assign-unassign-employee?client_id=" +
						clientId +
						(wageAccountType ? "&wage_account_type=" + wageAccountType : "") +
						(postingAccount ? "&posting_account=" + postingAccount : ""),
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},

	AssignUnassignMultipleEmployee: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse> => {
		let response: AxiosResponse<any>;
		response = await http.put<any>(
			// `/v1/statutory-holiday-employee-eligibility/update-bulk-employee-eligibility?association_flag=${requestPayload.flag}`,
			`/v1/wage-account-employee-assign/update-bulk-employee-eligibility?association_flag=${requestPayload.flag}`,
			requestPayload,
		);

		if (response.status === 201 || response.status === 200) {
			return {
				client: response.data,
				status: requestPayload.flag,
			};
		} else if (response.status === 400) {
			return {
				status: false,
				message: "400 Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
};
